import { createSelector } from 'reselect';

const slice = state => state.search.searchResults;

export const searchResultsSelector = createSelector(slice, ({ items }) => items);
export const searchResultsIsFetching = createSelector(slice, ({ isFetching }) => isFetching);

export const searchResultsHasMore = createSelector(
  searchResultsSelector,
  (results) => !!(results && results.nextPage)
);

export const searchResultsIsSearched = createSelector(
  slice,
  ({ query }) => !!query
);



// WEBPACK FOOTER //
// ./src/selectors/searchResults.js